import React from 'react';
import { Link } from 'react-router-dom';
import { VinCentrixLogo } from './Logo/VinCentrixLogo';
import { Twitter, Linkedin, Github, Mail, Phone } from 'lucide-react';

const Footer = () => {
  return (
    <footer style={{ 
      padding: '60px 40px 30px',
      borderTop: '1px solid rgba(255, 255, 255, 0.1)',
      background: 'linear-gradient(180deg, #0a0a10 0%, #000000 100%)',
      backdropFilter: 'blur(20px)',
      WebkitBackdropFilter: 'blur(20px)',
      fontFamily: "-apple-system, BlinkMacSystemFont, 'SF Pro Display', sans-serif"
    }}>
      {/* Main grid - 5 columns */}
      <div style={{ 
        display: 'grid', 
        gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr',
        gap: '60px',
        maxWidth: '1200px',
        margin: '0 auto 40px'
      }}>
        {/* Column 1: Logo + Tagline */}
        <div>
          <VinCentrixLogo size={48} showText={true} />
          <p style={{ 
            marginTop: '16px',
            fontSize: '14px',
            color: 'rgba(255,255,255,0.5)',
            fontFamily: "-apple-system, BlinkMacSystemFont, 'SF Pro Display', sans-serif",
            lineHeight: '1.6'
          }}>
            AI-powered CRM platform for automotive dealerships
          </p>
        </div>

        {/* Column 2: Product */}
        <div>
          <h4 style={{ 
            marginBottom: '16px', 
            fontSize: '16px',
            fontWeight: '600',
            color: '#ffffff',
            fontFamily: "-apple-system, BlinkMacSystemFont, 'SF Pro Display', sans-serif"
          }}>
            Product
          </h4>
          <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '12px' }}>
            <li>
              <Link 
                to="#features" 
                style={{ 
                  color: 'rgba(255, 255, 255, 0.6)', 
                  textDecoration: 'none', 
                  fontSize: '14px',
                  transition: 'all 0.3s ease',
                  fontFamily: "-apple-system, BlinkMacSystemFont, 'SF Pro Display', sans-serif"
                }}
                onMouseEnter={(e) => {
                  e.target.style.color = '#3b82f6';
                  e.target.style.textShadow = '0 0 10px rgba(59, 130, 246, 0.5)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.color = 'rgba(255, 255, 255, 0.6)';
                  e.target.style.textShadow = 'none';
                }}
              >
                Features
              </Link>
            </li>
            <li>
              <Link 
                to="#pricing" 
                style={{ 
                  color: 'rgba(255, 255, 255, 0.6)', 
                  textDecoration: 'none', 
                  fontSize: '14px',
                  transition: 'all 0.3s ease',
                  fontFamily: "-apple-system, BlinkMacSystemFont, 'SF Pro Display', sans-serif"
                }}
                onMouseEnter={(e) => {
                  e.target.style.color = '#3b82f6';
                  e.target.style.textShadow = '0 0 10px rgba(59, 130, 246, 0.5)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.color = 'rgba(255, 255, 255, 0.6)';
                  e.target.style.textShadow = 'none';
                }}
              >
                Pricing
              </Link>
            </li>
            <li>
              <Link 
                to="#demo" 
                style={{ 
                  color: 'rgba(255, 255, 255, 0.6)', 
                  textDecoration: 'none', 
                  fontSize: '14px',
                  transition: 'all 0.3s ease',
                  fontFamily: "-apple-system, BlinkMacSystemFont, 'SF Pro Display', sans-serif"
                }}
                onMouseEnter={(e) => {
                  e.target.style.color = '#3b82f6';
                  e.target.style.textShadow = '0 0 10px rgba(59, 130, 246, 0.5)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.color = 'rgba(255, 255, 255, 0.6)';
                  e.target.style.textShadow = 'none';
                }}
              >
                Request Demo
              </Link>
            </li>
          </ul>
        </div>

        {/* Column 3: Company */}
        <div>
          <h4 style={{ 
            marginBottom: '16px', 
            fontSize: '16px',
            fontWeight: '600',
            color: '#ffffff',
            fontFamily: "-apple-system, BlinkMacSystemFont, 'SF Pro Display', sans-serif"
          }}>
            Company
          </h4>
          <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '12px' }}>
            <li>
              <Link 
                to="#about" 
                style={{ 
                  color: 'rgba(255, 255, 255, 0.6)', 
                  textDecoration: 'none', 
                  fontSize: '14px',
                  transition: 'all 0.3s ease',
                  fontFamily: "-apple-system, BlinkMacSystemFont, 'SF Pro Display', sans-serif"
                }}
                onMouseEnter={(e) => {
                  e.target.style.color = '#3b82f6';
                  e.target.style.textShadow = '0 0 10px rgba(59, 130, 246, 0.5)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.color = 'rgba(255, 255, 255, 0.6)';
                  e.target.style.textShadow = 'none';
                }}
              >
                About
              </Link>
            </li>
            <li>
              <Link 
                to="#contact" 
                style={{ 
                  color: 'rgba(255, 255, 255, 0.6)', 
                  textDecoration: 'none', 
                  fontSize: '14px',
                  transition: 'all 0.3s ease',
                  fontFamily: "-apple-system, BlinkMacSystemFont, 'SF Pro Display', sans-serif"
                }}
                onMouseEnter={(e) => {
                  e.target.style.color = '#3b82f6';
                  e.target.style.textShadow = '0 0 10px rgba(59, 130, 246, 0.5)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.color = 'rgba(255, 255, 255, 0.6)';
                  e.target.style.textShadow = 'none';
                }}
              >
                Contact
              </Link>
            </li>
            <li>
              <Link 
                to="#careers" 
                style={{ 
                  color: 'rgba(255, 255, 255, 0.6)', 
                  textDecoration: 'none', 
                  fontSize: '14px',
                  transition: 'all 0.3s ease',
                  fontFamily: "-apple-system, BlinkMacSystemFont, 'SF Pro Display', sans-serif"
                }}
                onMouseEnter={(e) => {
                  e.target.style.color = '#3b82f6';
                  e.target.style.textShadow = '0 0 10px rgba(59, 130, 246, 0.5)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.color = 'rgba(255, 255, 255, 0.6)';
                  e.target.style.textShadow = 'none';
                }}
              >
                Careers
              </Link>
            </li>
          </ul>
        </div>

        {/* Column 4: Resources */}
        <div>
          <h4 style={{ 
            marginBottom: '16px', 
            fontSize: '16px',
            fontWeight: '600',
            color: '#ffffff',
            fontFamily: "-apple-system, BlinkMacSystemFont, 'SF Pro Display', sans-serif"
          }}>
            Resources
          </h4>
          <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '12px' }}>
            <li>
              <Link 
                to="#blog" 
                style={{ 
                  color: 'rgba(255, 255, 255, 0.6)', 
                  textDecoration: 'none', 
                  fontSize: '14px',
                  transition: 'all 0.3s ease',
                  fontFamily: "-apple-system, BlinkMacSystemFont, 'SF Pro Display', sans-serif"
                }}
                onMouseEnter={(e) => {
                  e.target.style.color = '#3b82f6';
                  e.target.style.textShadow = '0 0 10px rgba(59, 130, 246, 0.5)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.color = 'rgba(255, 255, 255, 0.6)';
                  e.target.style.textShadow = 'none';
                }}
              >
                Blog
              </Link>
            </li>
            <li>
              <Link 
                to="#docs" 
                style={{ 
                  color: 'rgba(255, 255, 255, 0.6)', 
                  textDecoration: 'none', 
                  fontSize: '14px',
                  transition: 'all 0.3s ease',
                  fontFamily: "-apple-system, BlinkMacSystemFont, 'SF Pro Display', sans-serif"
                }}
                onMouseEnter={(e) => {
                  e.target.style.color = '#3b82f6';
                  e.target.style.textShadow = '0 0 10px rgba(59, 130, 246, 0.5)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.color = 'rgba(255, 255, 255, 0.6)';
                  e.target.style.textShadow = 'none';
                }}
              >
                Documentation
              </Link>
            </li>
            <li>
              <Link 
                to="/privacy-policy" 
                style={{ 
                  color: 'rgba(255, 255, 255, 0.6)', 
                  textDecoration: 'none', 
                  fontSize: '14px',
                  transition: 'all 0.3s ease',
                  fontFamily: "-apple-system, BlinkMacSystemFont, 'SF Pro Display', sans-serif"
                }}
                onMouseEnter={(e) => {
                  e.target.style.color = '#3b82f6';
                  e.target.style.textShadow = '0 0 10px rgba(59, 130, 246, 0.5)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.color = 'rgba(255, 255, 255, 0.6)';
                  e.target.style.textShadow = 'none';
                }}
              >
                Privacy Policy
              </Link>
            </li>
            <li>
              <Link 
                to="/terms-of-service" 
                style={{ 
                  color: 'rgba(255, 255, 255, 0.6)', 
                  textDecoration: 'none', 
                  fontSize: '14px',
                  transition: 'all 0.3s ease',
                  fontFamily: "-apple-system, BlinkMacSystemFont, 'SF Pro Display', sans-serif"
                }}
                onMouseEnter={(e) => {
                  e.target.style.color = '#3b82f6';
                  e.target.style.textShadow = '0 0 10px rgba(59, 130, 246, 0.5)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.color = 'rgba(255, 255, 255, 0.6)';
                  e.target.style.textShadow = 'none';
                }}
              >
                Terms of Service
              </Link>
            </li>
          </ul>
        </div>

        {/* Column 5: Contact */}
        <div>
          <h4 style={{ 
            marginBottom: '16px', 
            fontSize: '16px',
            fontWeight: '600',
            color: '#ffffff',
            fontFamily: "-apple-system, BlinkMacSystemFont, 'SF Pro Display', sans-serif"
          }}>
            Contact
          </h4>
          <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '12px' }}>
            <li style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '14px', fontFamily: "-apple-system, BlinkMacSystemFont, 'SF Pro Display', sans-serif" }}>
              <Mail size={16} color="rgba(255, 255, 255, 0.4)" />
              <a 
                href="mailto:support@vincentrix.com" 
                style={{ 
                  color: 'rgba(255, 255, 255, 0.6)', 
                  textDecoration: 'none',
                  transition: 'all 0.3s ease'
                }}
                onMouseEnter={(e) => {
                  e.target.style.color = '#3b82f6';
                  e.target.style.textShadow = '0 0 10px rgba(59, 130, 246, 0.5)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.color = 'rgba(255, 255, 255, 0.6)';
                  e.target.style.textShadow = 'none';
                }}
              >
                support@vincentrix.com
              </a>
            </li>
            <li style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '14px', fontFamily: "-apple-system, BlinkMacSystemFont, 'SF Pro Display', sans-serif" }}>
              <Phone size={16} color="rgba(255, 255, 255, 0.4)" />
              <a 
                href="tel:+18005551234" 
                style={{ 
                  color: 'rgba(255, 255, 255, 0.6)', 
                  textDecoration: 'none',
                  transition: 'all 0.3s ease'
                }}
                onMouseEnter={(e) => {
                  e.target.style.color = '#3b82f6';
                  e.target.style.textShadow = '0 0 10px rgba(59, 130, 246, 0.5)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.color = 'rgba(255, 255, 255, 0.6)';
                  e.target.style.textShadow = 'none';
                }}
              >
                1-800-555-1234
              </a>
            </li>
          </ul>
        </div>
      </div>

      {/* Bottom bar */}
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingTop: '30px',
        borderTop: '1px solid rgba(255, 255, 255, 0.1)',
        maxWidth: '1200px',
        margin: '0 auto',
        flexWrap: 'wrap',
        gap: '20px'
      }}>
        <span style={{ 
          color: 'rgba(255,255,255,0.4)', 
          fontSize: '14px',
          fontFamily: "-apple-system, BlinkMacSystemFont, 'SF Pro Display', sans-serif"
        }}>
          © {new Date().getFullYear()} VinCentrix, LLC. All rights reserved.
        </span>

        {/* Social icons */}
        <div style={{
          display: 'flex',
          gap: '24px'
        }}>
          <a 
            href="https://twitter.com" 
            target="_blank" 
            rel="noopener noreferrer" 
            style={{ 
              color: 'rgba(255, 255, 255, 0.4)', 
              textDecoration: 'none',
              transition: 'all 0.3s ease'
            }}
            onMouseEnter={(e) => {
              e.target.style.color = '#3b82f6';
              e.target.style.filter = 'drop-shadow(0 0 8px rgba(59, 130, 246, 0.6))';
            }}
            onMouseLeave={(e) => {
              e.target.style.color = 'rgba(255, 255, 255, 0.4)';
              e.target.style.filter = 'none';
            }}
          >
            <Twitter size={20} />
          </a>
          <a 
            href="https://linkedin.com" 
            target="_blank" 
            rel="noopener noreferrer" 
            style={{ 
              color: 'rgba(255, 255, 255, 0.4)', 
              textDecoration: 'none',
              transition: 'all 0.3s ease'
            }}
            onMouseEnter={(e) => {
              e.target.style.color = '#3b82f6';
              e.target.style.filter = 'drop-shadow(0 0 8px rgba(59, 130, 246, 0.6))';
            }}
            onMouseLeave={(e) => {
              e.target.style.color = 'rgba(255, 255, 255, 0.4)';
              e.target.style.filter = 'none';
            }}
          >
            <Linkedin size={20} />
          </a>
          <a 
            href="https://github.com" 
            target="_blank" 
            rel="noopener noreferrer" 
            style={{ 
              color: 'rgba(255, 255, 255, 0.4)', 
              textDecoration: 'none',
              transition: 'all 0.3s ease'
            }}
            onMouseEnter={(e) => {
              e.target.style.color = '#3b82f6';
              e.target.style.filter = 'drop-shadow(0 0 8px rgba(59, 130, 246, 0.6))';
            }}
            onMouseLeave={(e) => {
              e.target.style.color = 'rgba(255, 255, 255, 0.4)';
              e.target.style.filter = 'none';
            }}
          >
            <Github size={20} />
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
